import { render, staticRenderFns } from "./SchemaHeader.vue?vue&type=template&id=af9df91a&scoped=true"
import script from "./SchemaHeader.vue?vue&type=script&lang=js"
export * from "./SchemaHeader.vue?vue&type=script&lang=js"
import style0 from "./SchemaHeader.vue?vue&type=style&index=0&id=af9df91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9df91a",
  null
  
)

export default component.exports